export default function modelSS({
    sazbaSS,
    poplatekSS,
    CC,
    dosporovani,
    minUkazatel,
    normovanyUrok,
    koeficient,
    preklopeni,
    vedeniUctuSS
}) {
    let i = 0

    let table = []

    // prvni radek
    let A = i + 1
    let R = 1
    let T = sazbaSS // T je konstantni
    let U = CC * - poplatekSS
    let V = 0
    let W = 0
    let X = 0
    let Y = 0
    let Z = 0
    let AA = 0
    let AB = 0

    let S = dosporovani + U + poplatekSS * CC

    table.push({
        A,
        R,
        S,
        T,
        U,
        V,
        W,
        X,
        Y,
        Z,
        AA,
        AB
    })

    let sumY = Y
    let sumZ = Z
    let p = 0

    while (S !== null) {
        p = i
        i++

        A++

        V = 0
        if (table[p].A % 12 === 0) {
            if (table[p].S !== null) {
                V = Math.max(0, table[p].S * table[p].T / 12)
            }
        } else {
            if (table[p].S !== null) {
                V = Math.max(0, table[p].S * table[p].T / 12 + table[p].V)
            }
        }

        U = 0
        if (table[p].S === null) {
            U = 0
        } else {
            if (A === 1) {
                U = CC * -poplatekSS
            } else {
                if (A % 12 === 0) {
                    U = vedeniUctuSS * -1
                } else {
                    if (A % 3 === 0) {
                        U = vedeniUctuSS * -1
                    } else {
                        U = 0
                    }
                }
            }
        }

        S = null
        if (table[p].S === null) {
            S = null
        } else {
            if (table[p].AA >= minUkazatel && table[p].S + V * 0.85 > CC * preklopeni) {
                S = null
            } else {
                if (A % 12 === 0) {
                    S = table[p].S + dosporovani + V * 0.85 + U
                } else {
                    if (table[p].R === 3) {
                        // i > 4 test na existujici index tabulky
                        S = table[p].S + dosporovani + (i > 4 ? Math.floor(table[i - 4].Y * 0.1) : 0) + U
                    } else {
                        S = table[p].S + dosporovani + U
                    }
                }
            }
        }

        if (S === null) {
            R = null
        } else {
            R = table[p].R + 1
            if (R > 12) {
                R = 1
            }
        }

        if (S === null) {
            T = null
        }

        W = Math.max(0, table[p].S * table[p].T / 12)

        X = R === null ? 0 : W + table[p].X

        Y = R === 12 ? Math.min(S - sumY - sumZ, 20000) : 0


        Z = 0

        if (i > 4 && R === 4) {
            Z = Math.floor(table[i - 4].Y * 0.1)
        }

        AA = X / sazbaSS * normovanyUrok * koeficient * Math.max(S / (CC * preklopeni), 1) / (0.001 * CC)

        sumY += Y
        sumZ += Z

        table.push({A, R, S, T, U, V, W, X, Y, Z, AA, AB})
    }

    // vyplata
    table[p].AB = table[p].S + V * 0.85

    // console.table(table)

    return table
}

// modelSS({
//     sazbaSS: 0.001,
//     poplatekSS: 0.01,
//     CC: 650000,
//     dosporovani: 5700,
//     minUkazatel: 64,
//     normovanyUrok: 0.03,
//     koeficient: 1.5,
//     preklopeni: 0.4,
//     vedeniUctuSS: 80
// })